import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, throwError, TimeoutError } from "rxjs";
import { environment } from "../../environments/environment";
import { switchMap, tap, timeoutWith } from "rxjs/operators";
import { log } from "../common/logger";

const logger = log("TimeoutInterceptor");

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const timeoutValue =
      Number(req.headers.get("timeout")) || environment.snoots.http.timeout;
    return next.handle(req).pipe(
      timeoutWith(
        timeoutValue,
        of(void 0).pipe(
          tap(() => {
            logger.warn(`req ${req.url} timeout!`);
          }),
          switchMap(() => throwError(new TimeoutError()))
        )
      )
    );
  }
}
